import React from 'react';

const AdminSignUpForm = ({
  firstName,
  lastName,
  email,
  password,
  confirmPassword,
  phone,
  errorMessage,
  loading,
  formSubmitted,
  handleChange,
}) => {
  return (
    <div className="admin__modal-column">
      <div className="form-group-row">
        <div className="form-group">
          <input
            type="text"
            name="firstName"
            value={firstName}
            onChange={handleChange}
            placeholder="First Name"
            className={formSubmitted && !firstName ? 'missing-field' : ''}
          />
          <div className="error-message-container">
            {formSubmitted && !firstName && <p className="error-message">First name is required</p>}
          </div>
        </div>

        <div className="form-group">
          <input
            type="text"
            name="lastName"
            value={lastName}
            onChange={handleChange}
            placeholder="Last Name"
            className={formSubmitted && !lastName ? 'missing-field' : ''}
          />
          <div className="error-message-container">
            {formSubmitted && !lastName && <p className="error-message">Last name is required</p>}
          </div>
        </div>
      </div>

      <div className="form-group-row">
      <div className="form-group">
        <input
          type="email"
          name="email"
          value={email}
          onChange={handleChange}
          placeholder="Email"
          className={formSubmitted && !email ? 'missing-field' : ''}
        />
        <div className="error-message-container">
          {formSubmitted && !email && <p className="error-message">Email is required</p>}
        </div>



      </div>
      <div className="form-group">
          <input
            type="tel"
            name="phone"
            value={phone}
            onChange={handleChange}
            placeholder="Phone Number"
            className={formSubmitted && !phone ? 'missing-field' : ''}
          />
          <div className="error-message-container">
            {formSubmitted && !phone && <p className="error-message">Phone number is required</p>}
          </div>
      </div>
      </div>
      
      <div className="form-group">
        <input
          type="password"
          name="password"
          value={password}
          onChange={handleChange}
          placeholder="Password"
          className={formSubmitted && !password ? 'missing-field' : ''}
        />
        <div className="error-message-container">
          {formSubmitted && !password && <p className="error-message">Password is required</p>}
        </div>
      </div>

      <div className="form-group">
        <input
          type="password"
          name="confirmPassword"
          value={confirmPassword}
          onChange={handleChange}
          placeholder="Confirm Password"
          className={formSubmitted && !confirmPassword ? 'missing-field' : ''}
        />
        <div className="error-message-container">
          {formSubmitted && !confirmPassword && <p className="error-message">Confirming the password is required</p>}
        </div>
      </div>

      {errorMessage && (
        <div className="error-message-container">
          <p className="error-message">{errorMessage}</p>
        </div>
      )}
    </div>
  );
};

export default AdminSignUpForm;